<div
  ngbDropdown
  class="d-inline-block"
  placement="left-top auto"
  display="dynamic"
  container="body"
  *ngIf="innerWidth > MAX_WIDTH; else mobile"
>
  <button
    class="btn btn-outline-primary btn-sm"
    ngbDropdownToggle
    id="dropdownMostrarColumnas-{{ id }}"
  >
    <i class="fas fa-columns"></i>
  </button>
  <div
    class="col-dropdown-menu"
    ngbDropdownMenu
    attr.aria-labelledby="dropdownMostrarColumnas-{{ id }}"
  >
    <div class="dropdown-content">
      <div *ngIf="datatable.columnas.length <= MAX_VALUES">
        <div
          *ngFor="let col of datatable.columnas; let i = index"
          class="switch-row"
        >
          <div class="custom-control custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              id="switch-{{ i + id }}"
              [(ngModel)]="col.mostrar"
              [ngModelOptions]="{ standalone: true }"
            />
            <label class="custom-control-label" for="switch-{{ i + id }}">{{
              col.nombre
            }}</label>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          datatable.columnas.length > MAX_VALUES &&
          datatable.columnas.length < MAX_VALUES_THREE_COL
        "
        class="content-two-column"
      >
        <div *ngFor="let dummy of counter(HALF); let i = index" class="row">
          <div class="col-md-6">
            <div class="switch-row">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-{{ i + id }}"
                  [(ngModel)]="datatable.columnas[i].mostrar"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label class="custom-control-label" for="switch-{{ i + id }}">{{
                  datatable.columnas[i].nombre
                }}</label>
              </div>
            </div>
          </div>
          <div *ngIf="i + HALF < datatable.columnas.length" class="col-md-6">
            <div class="switch-row">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-{{ i + id + HALF }}"
                  [(ngModel)]="datatable.columnas[i + HALF].mostrar"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label
                  class="custom-control-label"
                  for="switch-{{ i + id + HALF }}"
                  >{{ datatable.columnas[i + HALF].nombre }}</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="datatable.columnas.length >= MAX_VALUES_THREE_COL"
        class="content-three-column"
      >
        <div
          *ngFor="
            let dummy of counter(datatable.columnas.length);
            let i = index
          "
          class="row"
        >
          <div class="switch-row">
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                id="switch-{{ i + id }}"
                [(ngModel)]="datatable.columnas[i].mostrar"
                [ngModelOptions]="{ standalone: true }"
              />
              <label class="custom-control-label" for="switch-{{ i + id }}">{{
                datatable.columnas[i].nombre
              }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #mobile>
  <div
    ngbDropdown
    class="d-inline-block"
    placement="bottom-right auto"
    display="dynamic"
    container="body"
  >
    <button
      class="btn btn-outline-primary btn-sm"
      ngbDropdownToggle
      id="dropdownMostrarColumnasMobile"
    >
      <i class="fas fa-columns"></i>
    </button>
    <div
      class="col-dropdown-menu"
      ngbDropdownMenu
      aria-labelledby="dropdownMostrarColumnasMobile"
    >
      <div class="dropdown-content">
        <div
          *ngFor="let col of datatable.columnas; let i = index"
          class="switch-row"
        >
          <div class="custom-control custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              id="switch-{{ i + id }}"
              [(ngModel)]="datatable.columnas[i].mostrar"
              [ngModelOptions]="{ standalone: true }"
            />
            <label class="custom-control-label" for="switch-{{ i + id }}">{{
              datatable.columnas[i].nombre
            }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
